// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"SingleFileDrop_mainContainer__2cdoB","fileDropContainer":"SingleFileDrop_fileDropContainer__1m75m","fileDropLink":"SingleFileDrop_fileDropLink__2VFBp"};